import constants from "../constants";

const {
  GET_ALL_SUPPORT_CASES,
  UPDATE_SUPPORT_CASES_STORE,
  UPDATE_SUPPORT_CASE,
  UPDATE_SUPPORT_CASE_STORE,
  REMOVE_SUPPORT_CASE,
  REMOVE_SUPPORT_CASE_STORE,
} = constants;

export const getAllSupportCases = (data) => ({
  type: GET_ALL_SUPPORT_CASES,
  data,
});

export const updateAllSupportCasesStore = (data) => ({
  type: UPDATE_SUPPORT_CASES_STORE,
  data,
});

export const updateSupportCase = (data) => ({
  type: UPDATE_SUPPORT_CASE,
  data,
});

export const updateSupportCaseStore = (data) => ({
  type: UPDATE_SUPPORT_CASE_STORE,
  data,
});

export const removeSupportCase = (data) => ({
  type: REMOVE_SUPPORT_CASE,
  data,
});

export const removeSupportCaseStore = (data) => ({
  type: REMOVE_SUPPORT_CASE_STORE,
  data,
});
